import ProductPartTrigger from './productPartTrigger.component';
import ProductPartConnector from './productPartTrigger.props';

export default ProductPartConnector(ProductPartTrigger);
